 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTCONTENTS from '@/components/Text/Contents'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTTHANKS from '@/components/Text/Thanks'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTMAJORTHEMES from '@/components/Text/MajorThemes'
 import TEXTMATTHEW1 from '@/components/Text/Matthew1'
 import TEXTMATTHEW2 from '@/components/Text/Matthew2'
 import TEXTMATTHEW3 from '@/components/Text/Matthew3'
 import TEXTMATTHEW4 from '@/components/Text/Matthew4'
 import TEXTMATTHEW5 from '@/components/Text/Matthew5'
 import TEXTMATTHEW6 from '@/components/Text/Matthew6'
 import TEXTMATTHEW7 from '@/components/Text/Matthew7'
 import TEXTMATTHEW8 from '@/components/Text/Matthew8'
 import TEXTMATTHEW9 from '@/components/Text/Matthew9'
 import TEXTMATTHEW10 from '@/components/Text/Matthew10'
 import TEXTMATTHEW11 from '@/components/Text/Matthew11'
 import TEXTMATTHEW12 from '@/components/Text/Matthew12'
 import TEXTMATTHEW13 from '@/components/Text/Matthew13'
 import TEXTMATTHEW14 from '@/components/Text/Matthew14'
 import TEXTMATTHEW15 from '@/components/Text/Matthew15'
 import TEXTMATTHEW16 from '@/components/Text/Matthew16'
 import TEXTMATTHEW17 from '@/components/Text/Matthew17'
 import TEXTMATTHEW18 from '@/components/Text/Matthew18'
 import TEXTMATTHEW19 from '@/components/Text/Matthew19'
 import TEXTMATTHEW20 from '@/components/Text/Matthew20'
 import TEXTMATTHEW21 from '@/components/Text/Matthew21'
 import TEXTMATTHEW22 from '@/components/Text/Matthew22'
 import TEXTMATTHEW23 from '@/components/Text/Matthew23'
 import TEXTMATTHEW24 from '@/components/Text/Matthew24'
 import TEXTMATTHEW25 from '@/components/Text/Matthew25'
 import TEXTMATTHEW26 from '@/components/Text/Matthew26'
 import TEXTMATTHEW27 from '@/components/Text/Matthew27'
 import TEXTMATTHEW28 from '@/components/Text/Matthew28'
 import TEXTAPPENDIXA from '@/components/Text/AppendixA'
 import TEXTAPPENDIXB from '@/components/Text/AppendixB'
 import TEXTAPPENDIXC from '@/components/Text/AppendixC'
 import TEXTAPPENDIXD from '@/components/Text/AppendixD'
 import TEXTAPPENDIXE from '@/components/Text/AppendixE'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTRESOURCES from '@/components/Text/Resources'
 import TEXTABOUTTHEAUTHOR from '@/components/Text/AboutTheAuthor'
 import TEXTSERIES from '@/components/Text/Series'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Cover",
 			"name" : "Text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/Contents",
 			"name" : "Text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Thanks",
 			"name" : "Text/Thanks",
 			"component" : TEXTTHANKS
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/MajorThemes",
 			"name" : "Text/MajorThemes",
 			"component" : TEXTMAJORTHEMES
 		},
 		{
 			"path" : "/Text/Matthew1",
 			"name" : "Text/Matthew1",
 			"component" : TEXTMATTHEW1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js